import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../../common_components/common_widgets/popup";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import { isEqual } from "lodash";
import "./index.scss";
import {
  SET_BILL_HISTORY_CASE_DETAIL_DATA,
  SET_VISIBLE_IMPORT_CHARGES,
  TOGGLE_BILL_HISTORY_POPUP,
} from "./reducers/bill-history-reducer";
import MdaeButton from "../../../common_components/common_widgets/button";
import { actions } from "async-ops";
import { GET_CASE_BILLING_HISTORY } from "./services/get-case-billing-history";
import MdaeCheckBox from "../../../common_components/common_widgets/check-box";
import RemitDetail, {
  toggleRemitDetailPopupVisible,
} from "./remit-detail/component";
import ClaimDetail, {
  toggleClaimDetailPopupVisible,
} from "./claim-detail/component";
import { SET_CASE_FORM_DATA } from "../case-detail/case-data/reducers/case-data-reducer";
import MdaeRadioGroup from "../../../common_components/common_widgets/radio-group/component";
import { DISABLE_ANIMATION_CONFIG } from "../../../common_components/common_widgets/popup/component";
import { callOperation } from "async-ops";
import { SET_RISK_PAYER_CASE_DETAIL_ID } from "./services/set-risk-casedetailId";
import { GET_REMIT_DETAIL } from "./remit-detail/services/get-remit-detail";
import { GET_REMIT_LINE_LEVEL_ADJUSTMENT_DETAILS } from "./services/get-remit-line-level-adjustment-details";
import Guid from "devextreme/core/guid";
import { getNumber } from "./remit-detail/reducers/remit-detail-reducer";
import { HIDE_LOADER, SHOW_LOADER } from "../../../common_components/mdae-common-reducer";

export const toggleBillHistoryPopupVisible = (
  dispatch,
  isVisible,
  billData?,
  isVisibleToPopulateAtRiskField = false,
  varToUpdate ="",
  isVisibleFromImportCharges = false
) => {
  if (isVisible && billData) {
    dispatch({
      type: SET_BILL_HISTORY_CASE_DETAIL_DATA,
      data: {
        caseData: billData.parent,
        billingData: billData.child,
        isVisibleToPopulateAtRiskField: isVisibleToPopulateAtRiskField,
        varToUpdate: varToUpdate
      },
    });
    const caseBillingHistoryParams = {
      eaCaseId: billData.parent.eaCaseId,
      caseId: billData.parent.caseId,
      caseBranchNo: billData.child.caseBranchNo,
    };
    dispatch(
      actions.asyncOperationStart(
        GET_CASE_BILLING_HISTORY,
        caseBillingHistoryParams
      )
    );
  }
  dispatch({
    type: TOGGLE_BILL_HISTORY_POPUP,
    data: {
      isBillHistoryPopupVisible: isVisible,
    },
  });
  dispatch({
    type: SET_VISIBLE_IMPORT_CHARGES,
    data: {
      isVisibleFromImportCharges: isVisibleFromImportCharges,
    },
  });
};

const BillHistoryPopup: React.FC<any> = () => {
  const dispatch = useDispatch();

  const caseData = useSelector(
    (state) => state["billHistoryReducer"].caseData,
    isEqual
  );

  const billingData = useSelector(
    (state) => state["billHistoryReducer"].billingData,
    isEqual
  );
  const isVisibleToPopulateAtRiskField = useSelector(
    (state) => state["billHistoryReducer"].isVisibleToPopulateAtRiskField,
    isEqual
  );
  const varToUpdate = useSelector(
    (state) => state["billHistoryReducer"].varToUpdate,
    isEqual
  );
  var selectedValue = useSelector(
    (state) => state["billHistoryReducer"].selectedValue,
    isEqual
  );
  var isBillHistoryPopupVisible = useSelector(
    (state) => state["billHistoryReducer"].isBillHistoryPopupVisible,
    isEqual
  );
  const isVisibleFromImportCharges = useSelector(
    (state) => state["billHistoryReducer"].isVisibleFromImportCharges
  );
  const isImportType = useSelector(
    (state) => state["caseDataReducer"].isImportType
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData
  );
   const caseDataTemp = useSelector(
     (state) => state["caseDataReducer"].caseData
   );
  const currentImportRoundData = useSelector(
    (state) => state["caseDataReducer"].currentImportRoundData
  );

  const [
    billHistoryDataGridInstance,
    setBillHistoryDataGridInstance,
  ] = useState(null);

  const onBillHistoryDataGridInitialized = (e) => {
    setBillHistoryDataGridInstance(e.component);
  };

  const onBillHistoryGridRowClick = (e) => {
    let claimRemitType = e.data?.claimRemitType;
    let caseDetailId = e.data?.caseDetailId;
    let previewDisabled = false;
    if (selectedValue && isVisibleFromImportCharges) {
      previewDisabled = selectedValue !== caseDetailId;
    }
    if (isVisibleFromImportCharges) {
      if (claimRemitType === "Remit") {
        if (isImportType === "REMIT") {
          previewDisabled = !!selectedValue && selectedValue !== caseDetailId;
        } else if (isImportType === "CLAIM") {
          previewDisabled = true;
        }
      } else if (claimRemitType === "Claim") {
        if (isImportType === "REMIT") {
          previewDisabled = true;
        } else if (isImportType === "CLAIM") {
          previewDisabled = caseDetailData.caseDetailId !== caseDetailId;
        }
      }
    }
    if (previewDisabled) return;
    if (e.key?.caseDetailId && (isVisibleToPopulateAtRiskField || isVisibleFromImportCharges)) {
      var selectedValueKey = e.key.caseDetailId;
      dispatch({
        type: SET_BILL_HISTORY_CASE_DETAIL_DATA,
        data: {
          selectedValue: selectedValueKey,
        },
      });
      e.component.selectRows([e.key], false);
    }
  };
  const closeBillHistoryPopup = () => {
    toggleBillHistoryPopupVisible(dispatch, false, null, false);
    dispatch({
    type: SET_VISIBLE_IMPORT_CHARGES,
    data: {
      isVisibleFromImportCharges: false,
    },
  });
    if(!isVisibleToPopulateAtRiskField){dispatch({
      type: SET_BILL_HISTORY_CASE_DETAIL_DATA,
      data: {
        selectedValue: 0,
      },
    });
    billHistoryDataGridInstance.deselectAll();}
  };

  const billHistoryDataGridOptions = useMemo(() => {
    return getBillHistoryDataGridOptions(
      dispatch,
      caseData,
      billingData,
      isVisibleToPopulateAtRiskField,
      onBillHistoryDataGridInitialized,
      onBillHistoryGridRowClick,
      selectedValue,
      varToUpdate,
      isVisibleFromImportCharges,
      isImportType,
      caseDetailData.caseDetailId
    );
  }, [
    caseData,
    billingData,
    isVisibleToPopulateAtRiskField,
    onBillHistoryDataGridInitialized,
    selectedValue,
    varToUpdate,
    isVisibleFromImportCharges,
    isImportType,
    caseDetailData.caseDetailId
  ]);

  const getBillHistoryPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleBillHistoryPopupVisible(dispatch, false);
        }}
      >
        <span>
          {" "}
          Billing History -{" "}
          {billingData.sequence + " " + billingData.billTypeFacility}{" "}
        </span>
        <div className="bill-history-popup-title-details">
          <div className="patient-name-container">
            <div className="mdae-data-field-label title-label">Patient:</div>
            <div className="mdae-data-field-content title-value text-overflow-ellipsis">
              {caseData.patientFullName}
            </div>
          </div>
          <div className="account-number-container">
            <div className="mdae-data-field-label title-label">Account #:</div>
            <div className="mdae-data-field-content title-value text-overflow-ellipsis">
              {caseData.patientAcctNo}
            </div>
          </div>
          <div className="statement-from-date-container">
            <div className="mdae-data-field-label title-label">From Date:</div>
            <div className="mdae-data-field-content title-value text-overflow-ellipsis">
              {caseData.fromServiceDate}
            </div>
          </div>
          <div className="statement-to-date-container">
            <div className="mdae-data-field-label title-label">To Date:</div>
            <div className="mdae-data-field-content title-value text-overflow-ellipsis">
              {caseData.toServiceDate}
            </div>
          </div>
          <div className="total-charges-container">
            <div className="mdae-data-field-label title-label">
              Total Charges:{" "}
            </div>
            <div className="mdae-data-field-content title-value text-overflow-ellipsis">
              {billingData.totalCharges}
            </div>
          </div>
        </div>
      </MdaePopupTitle>
    );
  };

  return (
    <>
      <MdaePopup
        animation={DISABLE_ANIMATION_CONFIG}
        height={570}
        width={1300}
        mdaeTitleRender={getBillHistoryPopupTitle}
        visible={isBillHistoryPopupVisible}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <MdaeDataGrid {...billHistoryDataGridOptions}></MdaeDataGrid>
              </MdaePopupContent>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlCancelBillHistorySecondaryBtn"}
                  role={"secondary"}
                  onClick={() => {
                    closeBillHistoryPopup();
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlApplyBillHistoryPrimaryBtn"}
                  role={"primary"}
                  visible={isVisibleToPopulateAtRiskField || isVisibleFromImportCharges}
                  onClick={(e) => {
                    let selectedRows = billHistoryDataGridInstance.getSelectedRowsData();
                    if (selectedRows.length !== 1) {
                      if (selectedValue) {
                        const visibleRows = billHistoryDataGridInstance.getVisibleRows();
                        const alreadySelectedRow = visibleRows.filter(
                          (x) => selectedValue == x.data.caseDetailId
                        );
                        if (alreadySelectedRow.length === 1)
                          selectedRows = [alreadySelectedRow[0].data];
                        else return;
                      } else return;
                    }
                    const selectedRow = selectedRows[0];
                    if (selectedRow.claimRemitType == "Remit") {
                      let atRiskAmnt = parseFloat(
                        selectedRow.claimPayAmt.replace(/[$/,]/g, "")
                      );
                      if (isNaN(atRiskAmnt)) atRiskAmnt = 0;
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: { [varToUpdate === "totalRevenueLoss" ? "totalRevenueLoss" : `${varToUpdate}Amnt`]: atRiskAmnt },
                        },
                      });

                      callOperation(SET_RISK_PAYER_CASE_DETAIL_ID, {
                        caseDetailId: selectedRow.caseDetailId,
                        eaCaseId: caseData.eaCaseId,
                        SelectedCaseDetailIdFieldName: varToUpdate === "totalRevenueLoss"
                          ? "totalRevenueLossCaseDetailId"
                          : `${varToUpdate}CaseDetailId`,
                      });

                      if (varToUpdate === "atRisk") {
                        callOperation(GET_REMIT_DETAIL, {
                          caseDetailId: selectedRow.caseDetailId,
                        }).then((response) => {
                          dispatch({
                            type: SET_CASE_FORM_DATA,
                            data: {
                              caseData: {
                                payerRemitNo: response.extraFields.payerRemitNo,
                              },
                            },
                          });
                        });
                      }
                      if (isVisibleFromImportCharges) {
                        dispatch({ type: SHOW_LOADER });
                        callOperation(GET_REMIT_LINE_LEVEL_ADJUSTMENT_DETAILS, {
                          caseDetailId: selectedRow.caseDetailId,
                        }).then((response) => {
                          let lineLevelAdjustmentList = response;
                          if(lineLevelAdjustmentList?.length > 0){


                          let caseData = caseDataTemp;
                          const currentRound = caseData.roundData.find(
                            (round) =>
                              round.eaRoundCaseId ===
                              currentImportRoundData.eaRoundCaseId
                          );
                          let roundCharges = currentRound
                            ? currentRound.roundCharges || []
                            : [];
                          let newCharges = [];
                          lineLevelAdjustmentList.forEach((adj) => {
                            if (adj?.state === "Billed") {
                              return; // Skip billed adjustments
                            }
                            // Add HCPCS if present and not already present with same atRiskAmnt
                            if (adj.hcpcsCode) {
                              newCharges.push({
                                roundTargetType: "CPTHCPCS",
                                roundTargetValue: adj.hcpcsCode,
                                eaRoundCaseLineLevelTrackingIdString: new Guid().toString(),
                                billingCaseDetailId: selectedRow.caseDetailId,
                                claimRemitType: "REMIT",
                                revenueCode: adj.revCode,
                                atRiskAmnt: getNumber(adj.providerPayment),
                                targetId: adj.casePayLineId,
                              });
                            }
                            // Add Modifier if present and not already present with same atRiskAmnt
                            // Only add providerPayment to modifier if no hcpcsCode
                            if (adj.modifiers && !adj.hcpcsCode) {
                              newCharges.push({
                                roundTargetType: "MODIFIER",
                                roundTargetValue: adj.modifiers,
                                eaRoundCaseLineLevelTrackingIdString: new Guid().toString(),
                                billingCaseDetailId: selectedRow.caseDetailId,
                                claimRemitType: "REMIT",
                                revenueCode: adj.revCode,
                                atRiskAmnt: getNumber(adj.providerPayment),
                                targetId: adj.casePayLineId,
                              });
                            }
                            // If both present, add modifier as well (but without atRiskAmnt)
                            if (adj.hcpcsCode && adj.modifiers) {
                              newCharges.push({
                                roundTargetType: "MODIFIER",
                                roundTargetValue: adj.modifiers,
                                eaRoundCaseLineLevelTrackingIdString: new Guid().toString(),
                                billingCaseDetailId: selectedRow.caseDetailId,
                                claimRemitType: "REMIT",
                                revenueCode: adj.revCode,
                                atRiskAmnt: 0,
                                targetId: adj.casePayLineId,
                              });
                            }
                          });

                          //  3. Update roundData → remove unchecked, add new checked
                          const updatedRoundData = caseData.roundData.map(
                            (round) => {
                              if (
                                round.eaRoundCaseId ===
                                currentImportRoundData.eaRoundCaseId
                              ) {
                                const filteredCharges = round.roundCharges.filter(
                                  (charge) => {
                                    // Keep if not REMIT, or if present in unSavedSelectedTypeList
                                    if (charge.claimRemitType !== "REMIT")
                                      return true;
                                    // Remove REMIT charges whose billingCaseDetailId does not match caseDetailId
                                    if (
                                      charge.claimRemitType === "REMIT" &&
                                      charge.billingCaseDetailId !==
                                        selectedRow.caseDetailId
                                    ) {
                                      return false;
                                    }
                                  }
                                );
                                return {
                                  ...round,
                                  roundCharges: [
                                    ...filteredCharges,
                                    ...newCharges,
                                  ],
                                };
                              }
                              return round;
                            }
                          );

                          dispatch({
                            type: SET_CASE_FORM_DATA,
                            data: {
                              caseData: {
                                ...caseData,
                                [varToUpdate === "totalRevenueLoss" ? "totalRevenueLoss" : `${varToUpdate}Amnt`]: atRiskAmnt,
                                roundData: updatedRoundData,
                              },
                            },
                          });
                        }
                          dispatch({ type: HIDE_LOADER });
                        });
                      }

                      closeBillHistoryPopup();
                    } else {
                      return;
                    }
                  }}
                >
                  Apply
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
      <RemitDetail ></RemitDetail>
      <ClaimDetail></ClaimDetail>
    </>
  );
};

export const viewClaimRemitDetails = (dispatch, caseData, billingData, rowData,varToUpdate) => {
  if (rowData.claimRemitType == "Remit") {
    const params = {
      caseDetailId: rowData.caseDetailId,
      patientType: billingData.billTypeFacility,
      claimType: caseData.claimType,
      eaCaseId : caseData.eaCaseId,
      varToUpdate: varToUpdate === 'importCharges' ? '' : varToUpdate
    };
    toggleRemitDetailPopupVisible(dispatch, true, params);
  } else {
    toggleClaimDetailPopupVisible(dispatch, true, caseData);
  }
};
const getBillHistoryDataGridOptions = (
  dispatch,
  caseData,
  billingData,
  isVisibleToPopulateAtRiskField,
  onBillHistoryDataGridInitialized,
  onBillHistoryGridRowClick,
  selectedValue,
  varToUpdate,
  isVisibleFromImportCharges,
  isImportType,
  currentCaseDetailId
) => {
  const billHistoryDataGridOption: IMdaeDataGridProps = {
    id: "grdBillHistory",
    allowColumnResizing: true,
    scrolling: {
      columnRenderingMode: "virtual",
    },
    paging: {
      pageSize: 20,
    },
    pager: {
      displayMode: "full",
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 30],
      showInfo: true,
    },
    height: 360,
    keyExpr: "caseDetailId",
    onInitialized: onBillHistoryDataGridInitialized,
    onRowClick: onBillHistoryGridRowClick,
    mdaeColumns: [
      {
        width: 40,
        caption: "",
        fixed: true,
        visible: isVisibleToPopulateAtRiskField || isVisibleFromImportCharges,
        cellRender: (cellData) => {
          let claimRemitType = cellData.data.claimRemitType;
          let caseDetailId = cellData.data.caseDetailId;

          if (claimRemitType !== "Claim") {
            let radioDisabled = false;
            if (selectedValue && isVisibleFromImportCharges) {
              radioDisabled = selectedValue !== caseDetailId;
            }

            return (
              <MdaeRadioGroup
                id={"radioGroup_" + caseDetailId}
                valueExpr="caseDetailId"
                value={selectedValue}
                disabled={radioDisabled}
                items={[{ caseDetailId }]}
              />
            );
          }
        },
      },
      {
        dataField: "auditOverrideInd",
        width: 53,
        caption: "Override",
        fixed: true,
        cellRender: (cellData) => {
          let claimRemitType = cellData.data.claimRemitType;
          if (claimRemitType === "Claim") {
            return (
              <MdaeCheckBox
                id=""
                value={cellData.data.auditOverrideInd}
                disabled={true}
              />
            );
          } else return "";
        },
      },
      {
        dataField: "accumulationIncludeInd",
        width: 50,
        caption: "Original",
        fixed: true,
        cellRender: (cellData) => {
          return (
            <MdaeCheckBox
              id=""
              value={cellData.data.accumulationIncludeInd}
              disabled={true}
            />
          );
        },
      },
      {
        dataField: "newRecordInd",
        width: 40,
        caption: "New",
        fixed: true,
        cellRender: (cellData) => {
          return (
            <MdaeCheckBox
              id=""
              value={cellData.data.newRecordInd}
              disabled={true}
            />
          );
        },
      },
      {
        dataField: "billDate",
        caption: "Bill/Remit",
        allowFiltering: false,
        width: 100,
        allowHeaderFiltering: false,
        fixed: true,
        dataType: "date",
        format: "MM/dd/yyyy",
      },
      {
        dataField: "caseId",
        width: 40,
        caption: "",
        fixed: true,
        cellRender: (cellData) => {
          let claimRemitType = cellData.data.claimRemitType;
          let caseDetailId = cellData.data.caseDetailId;
          let previewDisabled = false;
          if (selectedValue && isVisibleFromImportCharges) {
            previewDisabled = selectedValue !== caseDetailId;
          }
          if (isVisibleFromImportCharges) {
            if (claimRemitType === "Remit") {
              if (isImportType === "REMIT") {
                previewDisabled = !!selectedValue && selectedValue !== caseDetailId;
              } else if (isImportType === "CLAIM") {
                previewDisabled = true;
              }
            } else if (claimRemitType === "Claim") {
              if (isImportType === "REMIT") {
                previewDisabled = true;
              } else if (isImportType === "CLAIM") {
                previewDisabled = currentCaseDetailId !== caseDetailId;
              }
            }
          }
          return (
            <div className={"bill-history-preview-action"}>
              <i
                style={{ height: "14px", cursor: "pointer", ...previewDisabled ? { pointerEvents: "none", opacity: 0.5 } : {} }}
                className={"preview-action-icon"}
                onClick={(e) => {
                  viewClaimRemitDetails(
                    dispatch,
                    caseData,
                    billingData,
                    cellData.data,
                    varToUpdate
                  );
                }}
              ></i>
            </div>
          );
        },
      },
      {
        dataField: "claimRemitType",
        caption: "Type",
        allowFiltering: false,
        width: 60,
        allowHeaderFiltering: false,
        fixed: true,
      },
      {
        dataField: "payerName",
        caption: "Payer",
        allowFiltering: false,
        width: 100,
        allowHeaderFiltering: false,
        fixed: true,
      },
      {
        dataField: "claimFrequencyCodeDesc",
        caption: "Frequency",
        allowFiltering: false,
        width: 80,
        allowHeaderFiltering: false,
        fixed: true,
      },
      {
        dataField: "claimStatusCodeDesc",
        caption: "Claim Status",
        allowFiltering: false,
        width: 80,
        allowHeaderFiltering: false,
        fixed: true,
      },
      {
        dataField: "patientAcctNoOrig",
        caption: "Account #",
        allowFiltering: false,
        width: 110,
        allowHeaderFiltering: false,
        fixed: true,
      },
      {
        dataField: "statementFromDate",
        caption: "From Date",
        allowFiltering: false,
        width: 100,
        allowHeaderFiltering: false,
      },
      {
        dataField: "statementToDate",
        caption: "To Date",
        allowFiltering: false,
        width: 100,
        allowHeaderFiltering: false,
      },
      {
        dataField: "totalClaimChargeAmt",
        caption: "Total Chg",
        allowFiltering: false,
        width: 90,
        allowHeaderFiltering: false,
        alignment: "right",
      },
      {
        dataField: "claimPayAmt",
        caption: "Paid Amt",
        allowFiltering: false,
        width: 90,
        allowHeaderFiltering: false,
        alignment: "right",
      },
      {
        dataField: "patientResponsibilityAmt",
        caption: "Pt Responsibility",
        allowFiltering: false,
        width: 100,
        allowHeaderFiltering: false,
        alignment: "right",
      },
      {
        dataField: "drgCode",
        caption: "DRG",
        allowFiltering: false,
        width: 60,
        allowHeaderFiltering: false,
        cellRender: (cellData) => {
          return (
            <div title={cellData.data.drgDescription}>
              {cellData.data.drgCode}
            </div>
          );
        },
      },
      {
        dataField: "loadMessage",
        caption: "Load Message",
        allowFiltering: false,
        width: 150,
        allowHeaderFiltering: false,
      },
    ],
    mdaeDataUpdaterConfig: [
      {
        actionType: GET_CASE_BILLING_HISTORY,
        isAsyncComplete: true,
        widgetOptionBindings: {
          dataSource: undefined,
        },
      },
    ],
  };
  return billHistoryDataGridOption;
};

export default BillHistoryPopup;
